export default {
    type: 'person-blog-posts',
    aliases: {
        camel: 'personBlogPosts',
        singular: 'Person blog post',
        plural: 'Person blog posts',
        lowerSingular: 'person blog post',
        lowerPlural: 'person blog posts',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
